export default __webpack_public_path__ + "static/media/bbcd.e9c86a8b.svg";